import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '@scss/page_login.scss';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {TextField} from '@material-ui/core';
import {refreshCaptcha, registration} from '@componentDP/js_react/redux/actions/login';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {delay} from '@helpers/functions';
import {cloneDeep} from 'lodash';
import {withTranslation} from "react-i18next";

const styles = theme => ({
    themeDirection: theme.direction,
    h4: {
        fontWeight: 'bold',
        paddingBottom: '20px',
    },
    loginBtn: {
        backgroundColor: '#009be5',
        width: '100%',
        padding: '15px 0px',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: '#0082c0',
        }
    },
});

class PageAuthRegistrationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            captcha: '',
            isCheckedPersonalData: false,
            isShowPersonalDataDetails: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleRegistration = this.handleRegistration.bind(this);
        this.handleChangePersonalData = this.handleChangePersonalData.bind(this);
        this.handleChangePersonalDataDetails = this.handleChangePersonalDataDetails.bind(this);
        this.handleAgreePersonalDataDetails = this.handleAgreePersonalDataDetails.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.handleRefreshCaptcha = this.handleRefreshCaptcha.bind(this);
        const {refreshCaptcha} = props;
        refreshCaptcha();
    }
    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value});
    };
    handleRegistration() {
        const {registration, t} = this.props;
        const {name, email, password, password_confirmation, captcha} = this.state;
        delay(() => {
            registration({name, email, password, password_confirmation, captcha}, t);
        }, 200);
    };
    handleLogin() {
        location.hash = '/';
    };
    handleChangePersonalData() {
        const {isCheckedPersonalData} = this.state;
        this.setState({isCheckedPersonalData: !isCheckedPersonalData});
    };
    handleChangePersonalDataDetails() {
        const {isShowPersonalDataDetails} = this.state;
        this.setState({isShowPersonalDataDetails: !isShowPersonalDataDetails});
    };
    handleAgreePersonalDataDetails() {
        this.setState({isCheckedPersonalData: true, isShowPersonalDataDetails: false});
    };
    handleForgotPassword() {
        location.hash = 'forgot-password';
    };
    handleRefreshCaptcha() {
        const {refreshCaptcha} = this.props;
        refreshCaptcha();
    }
    render() {
        const {
            handleChange,
            handleLogin,
            handleRegistration,
            handleChangePersonalData,
            handleChangePersonalDataDetails,
            handleAgreePersonalDataDetails,
            handleForgotPassword,
            handleRefreshCaptcha,
        } = this;
        const {
            name,
            email,
            password,
            password_confirmation,
            captcha,
            isCheckedPersonalData,
            isShowPersonalDataDetails,
        } = this.state;
        const {classes, captchaImg, t, i18n} = this.props;
        return(
            <form>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography align="center" variant="h6">
                            {t('registration')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="text"
                            label={t('fio')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="name"
                            value={name}
                            onChange={(e) => {
                                handleChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="email"
                            label="E-mail"
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="email"
                            value={email}
                            onChange={(e) => {
                                handleChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="password"
                            label={t('password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password"
                            value={password}
                            onChange={(e) => {
                                handleChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="password"
                            label={t('confirm_password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password_confirmation"
                            value={password_confirmation}
                            helperText={t('min_8_chars')}
                            onChange={(e) => {
                                handleChange(e);
                            }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <img src={captchaImg} alt="captcha" />
                                <Link className="cursor-pointer" onClick={handleRefreshCaptcha}>
                                    <Typography variant="body1" align="center">
                                        {t('update')}
                                    </Typography>
                                </Link>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    type="text"
                                    label={t('picture_code')}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="captcha"
                                    value={captcha}
                                    onChange={(e) => {
                                        handleChange(e);
                                    }} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={isCheckedPersonalData}
                                    onChange={handleChangePersonalData}
                                    name="is_checked_personal_data" />
                            }
                            label={t('confirm_personal_data_consent')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Link className="cursor-pointer" onClick={handleChangePersonalDataDetails}>
                            <Typography variant="body1">{t('details')}</Typography>
                        </Link>
                        <Dialog
                            open={isShowPersonalDataDetails}
                            onClose={handleChangePersonalDataDetails}>
                            <DialogTitle>{t('personal_data_consent_confirmation')}</DialogTitle>
                            {i18n.language === "en"
                                ? <DialogContent>
                                    <Typography variant="body1" align="justify">
                                        In accordance with Article 9 of Federal Law No. 152-FZ of July 27, 2006, "On
                                        Personal Data,"
                                        I hereby consent to the processing of my personal data by the operator,
                                        Limited Liability Company "National Fund for Supporting Innovations in
                                        Education,"
                                        registered at: 424000, Yoshkar-Ola, Volkova St., 206A, using automated means or
                                        without such means.
                                    </Typography>
                                    <br/>
                                    <Typography variant="body1" align="justify">
                                        For the purposes of: ensuring compliance with current regulatory and
                                        non-regulatory legal acts,
                                        including orders of the Russian Ministry of Education and Science approving the
                                        Procedure for Admission
                                        to Higher Education Programs; enabling participation in the admission campaign
                                        at educational institutions;
                                        informing federal executive authorities, regional executive authorities,
                                        municipal executive authorities,
                                        enterprises, organizations, and institutions about enrollment in an educational
                                        institution in accordance
                                        with the terms of the agreement; transferring information to the federal
                                        information system for conducting
                                        state final certification of students who have completed basic general and
                                        secondary general education programs,
                                        as well as for admitting citizens to educational institutions for secondary
                                        vocational and higher education;
                                        publishing on the corporate website information about applicants, including
                                        admission or rejection of documents,
                                        enrollment orders, participation in entrance examinations, and their results.
                                    </Typography>
                                    <br/>
                                    <Typography variant="body1" align="justify">
                                        The list of personal data provided to the Operator for processing includes: Last
                                        name, first name, patronymic;
                                        Citizenship; Date of birth; Place of birth; Gender; Registration address; Actual
                                        residence address;
                                        Home phone number; Mobile phone number; Passport details; Information confirming
                                        eligibility for benefits
                                        under legally established grounds; Education (when and which educational
                                        institutions were completed);
                                        Photographic image; Foreign language proficiency; Education certificate; Unified
                                        State Exam (USE) results;
                                        Entrance examination results; Information on the need for special conditions
                                        during entrance examinations due to disability;
                                        Information on individual achievements (if any).
                                        The following actions will be performed: collection, recording, systematization,
                                        accumulation, storage, updating,
                                        retrieval, use, transfer (distribution, provision, access), anonymization,
                                        blocking,
                                        deletion, and destruction of personal data, both with and without automated
                                        means.
                                        I agree that the Operator may verify the accuracy of the personal data I have
                                        provided,
                                        including through third-party operators, without notifying me.
                                        This consent is effective upon confirmation and remains valid until the
                                        expiration of the personal file retention
                                        period at the educational institution or until revoked.
                                        I may withdraw this consent at any time by submitting a written request.
                                    </Typography>
                                </DialogContent>
                                : <DialogContent>
                                    <Typography variant="body1" align="justify">
                                        В соответствии со статьей 9 Федерального закона от 27.07.2006 N 152-ФЗ "О
                                        персональных данных" даю согласие на обработку своих персональных данных
                                        оператору Обществу с ограниченной ответственностью «Национальный фонд поддержки
                                        инноваций в сфере образования», зарегистрированному по адресу: 424000, город
                                        Йошкар-Ола, ул. Волкова, д. 206А, с использованием средств автоматизации или
                                        без использования таких средств.
                                    </Typography>
                                    <br />
                                    <Typography variant="body1" align="justify">
                                        С целью: обеспечение исполнения действующих нормативных и ненормативных
                                        правовых актов, в том числе приказов Минобрнауки России, утверждающих Порядок
                                        приёма на обучение по образовательным программам высшего образования;
                                        обеспечение возможности участия в приемной кампании в образовательных
                                        организациях; информирования федеральных органов исполнительной власти, органов
                                        исполнительной власти субъектов РФ, органов исполнительной власти муниципальных
                                        образований и предприятий, организаций и учреждений о поступлении в
                                        образовательную организацию в соответствие с условиями договора; передача
                                        сведений и данных в федеральную информационную систему обеспечения проведения
                                        государственной итоговой аттестации обучающихся освоивших основные
                                        образовательные программы основного общего и среднего общего образования, и
                                        приёма граждан в образовательные организации для получения среднего
                                        профессионального и высшего образования; размещение на корпоративном сайте
                                        сведений о лицах, подавших документы, необходимые для поступления, с указанием
                                        сведений о приёме или об отказе в приёме документов, приказов о зачислении, об
                                        участии в прохождении вступительных испытаний и результатов таких испытаний;
                                    </Typography>
                                    <br />
                                    <Typography variant="body1" align="justify">
                                        Перечень персональных данных, передаваемых Оператору на обработку: Фамилия, имя,
                                        отчество; Гражданство; Дата рождения; Место рождения; Пол; Адрес регистрации;
                                        Адрес фактического проживания; Номер домашнего телефона; Номер мобильного
                                        телефона; Данные паспорта; Сведения, подтверждающие право на льготы по
                                        определенным основаниям, предусмотренным законодательством; Образование (когда
                                        и какие учебные заведения окончил); Фотографическое изображение; Владение
                                        иностранными языками; Документ об образовании; Результаты ЕГЭ; Данные о
                                        результатах вступительных испытаний; Сведения о необходимости создания для
                                        поступающего специальных условий при проведении вступительных испытаний в связи
                                        с его инвалидностью; Сведения о наличии или отсутствии индивидуальных
                                        достижений; Для совершения следующих действий: сбор, запись, систематизация,
                                        накопление, хранение, уточнение (обновление, изменение), извлечение,
                                        использование, передача (распространение, предоставление, доступ),
                                        обезличивание, блокирование, удаление, уничтожение персональных данных, как с
                                        использованием средств автоматизации, так и без использования средств
                                        автоматизации. Я согласен(а) с тем, что оператор может проверить достоверность
                                        предоставленных мною персональных данных, в том числе с использованием услуг
                                        других операторов, без уведомления меня об этом. Настоящее согласие действует с
                                        момента его подтверждения и до истечения срока хранения личного дела в
                                        образовательной организации либо до его отзыва. Согласие может быть отозвано
                                        мною в любое время на основании моего письменного заявления.
                                    </Typography>
                                </DialogContent>
                            }
                            <DialogActions>
                                <Button onClick={handleAgreePersonalDataDetails} color="primary">
                                    {t('agreed')}
                                </Button>
                                <Button onClick={handleChangePersonalDataDetails} color="primary" autoFocus>
                                    {t('close')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                    <Grid item xs={12} className={classes.alignCenter}>
                        <Button
                            variant="contained"
                            onClick={handleRegistration}
                            className={classes.loginBtn}
                            disabled={!isCheckedPersonalData}>
                            {t('register')}
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Link className="cursor-pointer" onClick={() => {handleLogin()}}>
                            <Typography variant="body1" align="center">
                                {t('is_registered')}
                            </Typography>
                        </Link>
                    </Grid>
                    <Grid item xs={12}>
                        <Link className="cursor-pointer" onClick={handleForgotPassword}>
                            <Typography variant="body1" align="center">
                                {t('forgot_password')}
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
        captchaImg: cloneDeep(state.captchaImg),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        refreshCaptcha,
        registration,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(PageAuthRegistrationContainer));
